module.exports = __webpack_public_path__ + "static/media/testimonial@2x.c6b869f9.png";